module.exports = {
      id: "arrow-special-usage",
      viewBox: "0 0 33 14",
      url: __webpack_public_path__ + "img/icons.bfe893b5.svg#arrow-special-usage",
      toString: function () {
        return this.url;
      }
    }